import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { paymentSaveApi } from "../CustomerCRUD";
import { toast } from "react-toastify";
import { clearCart } from "../../../store/cartSlice";
import { useDispatch } from "react-redux";

const PaymentPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState(1);
  const [paying, setPaying] = useState(false);

  const methods = [
    { id: 1, name: "UPI" },
    { id: 2, name: "Card" },
    { id: 3, name: "NetBanking" },
    { id: 4, name: "COD" },
  ];

  useEffect(() => {
    const storedOrder = localStorage.getItem("order");
    setOrder(storedOrder ? JSON.parse(storedOrder) : null);
    setLoading(false);
  }, []);

  const handlePayment = async () => {
    if (!order) return;
    setPaying(true);
    try {
      const res = await paymentSaveApi(
        parseInt(id),
        paymentMethod,
        order.subTotal
      );

      if (res.data.isSuccess) {
        toast.success("Payment saved successfully");
        // navigate(`/order-confirmation/${orderID}`);

        // localStorage.removeItem("customer");
        // localStorage.removeItem("checkoutAddress");
        localStorage.removeItem("order");

        // Clear Redux cart
        dispatch(clearCart());
        navigate("/page/categories", { replace: true });
      } else {
        alert("Payment failed, please try again.");
      }
    } catch (err) {
      alert("Error processing payment.");
    } finally {
      setPaying(false);
    }
  };

  if (loading || !order) {
    return <p className="text-center py-10">Loading order...</p>;
  }

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <h5 className="fs-5 mb-6 text-center">Payment</h5>

      <Card className="rounded-2xl mb-6">
        <div className="p-6">
          <h6 className="text-xl font-semibold mb-4">Order Summary</h6>
          <p>
            <strong>Sub Total:</strong> ₹{order.subTotal}
          </p>
          {/* <p className="text-lg font-bold mt-2">
            <strong>Final Total:</strong> ₹{order.finalTotal}
          </p> */}
        </div>
      </Card>

      <Card className="rounded-2xl mb-6">
        <div className="p-6">
          <p className="fs-6 mb-4">Choose Payment Method</p>
          <div className="space-y-3">
            {methods.map((method) => (
              <label
                key={method.id}
                className={`flex items-center p-3 border rounded-lg cursor-pointer ${
                  paymentMethod === method.id
                    ? "bg-blue-100 border-blue-500"
                    : "border-gray-300"
                }`}
              >
                <input
                  type="radio"
                  name="paymentMethod"
                  value={method.id}
                  checked={paymentMethod === method.id}
                  onChange={(e) => setPaymentMethod(Number(e.target.value))}
                  className="mr-3"
                />
                {method.name}
              </label>
            ))}
          </div>
        </div>
      </Card>

      <div className="text-center">
        <Button
          onClick={handlePayment}
          disabled={paying}
          className="w-48 py-3 text-lg rounded-xl shadow-md"
        >
          {paying ? "Processing..." : `Pay ₹${order.finalTotal}`}
        </Button>
      </div>
    </div>
  );
};

export default PaymentPage;
